import baseStyled, { css as baseCss, ThemedCssFunction, ThemedStyledInterface } from 'styled-components';


import Card from '@plasma/ui.display.card';
import Button from '@plasma/ui.general.button';
import Input from '@plasma/ui.input.input';
import Select from '@plasma/ui.input.select';
import Modal from '@plasma/ui.layout.modal';

import { ProductDetailTheme } from './themes/types';

const styled = baseStyled as ThemedStyledInterface<ProductDetailTheme>;
const css = baseCss as ThemedCssFunction<ProductDetailTheme>;

export const ProductDetail = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${(props) => props.theme.mode.productDetail.backgroundColor};
  background: ${(props) => props.theme.mode.productDetail.backgroundGradient};
`;

export const CustomModal = styled(Modal)`
  width: 320px !important;
`;

export const ListContainerDiv = styled.div<{ maxHeight: boolean }>`
  max-height: ${(props) => (props.maxHeight ? '10vh' : 'none')};
  min-height: 11vh;
  overflow-y: auto;
  width: 27vh;
`;

export const ListContainerItem = styled.div`
  margin: 2px 0px 0px 5px;
  color: ${(props) => props.theme.mode.productDetail.textColor}
`;

export const AddProfileButton = styled(Button)`
  margin: 40px 20px 10px 35px;
  background-color: ${(props) => props.theme.mode.productDetail.normalButtonBGColor} !important;
  border: 2px solid ${(props) => props.theme.mode.productDetail.normalButtonBorderColor} !important;
`;

export const ModalContainer = styled.div`
  background: linear-gradient(to top left, #f0f0f5, ${(props) => props.theme.mode.productDetail.backgroundColor});
  padding: 15px 20px 20px 20px;
  border-radius: 5px;
`;

export const SwitchContainer = styled.div<{ isActive: boolean }>`
  display: flex;
  align-items: center;
  width: 142px;
  margin: 0px 0px 5px 312px;
  background-color: ${(props) => (props.isActive ? '#f2ffcc' : '#c2c2c2')};
  box-shadow: ${(props) => (props.isActive ? '5px 7px 15px 10px #f2ffcc' : 'none')};
  padding: 6px 10px;
  border: 2px solid ${(props) => props.theme.mode.productDetail.borderColor};
  border-radius: 5px;
`;

export const SwitchLabel = styled.div<{ isActive: boolean }>`
  font-weight: bold;
  margin-right: 10px;
  font-size: 14px;
  color: ${(props) => props.isActive ? "black" : props.theme.mode.productDetail.textColor};
`;

export const ProfileContainer = styled.div`
  display: flex;
`;

export const ProfileAndSelectContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ProfileDetailsContainer = styled.div`
  font-weight: bold;
  margin: 0px 0px 15px 0px;
  text-decoration: underline;
  font-size: 17px;
  width: 100%;

`;

export const SelectContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 3px;
`;

export const PopConfirmContainer = styled.div`
  align-self: flex-end;
  margin-left: auto;
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FormRow = styled.div<{ marginTop?: string }>`
  display: flex;
  align-items: flex-start;
  margin-bottom: 20px;
  margin-top: ${(props) => props.marginTop || '0px'};
`;

export const FormLabel = styled.div`
  width: 130px;
  font-weight: bold;
  margin-right: 30px;
  font-size: 15px;
  border: 1px solid ${(props) => props.theme.mode.productDetail.borderColor};
  background-color: ${(props) => props.theme.mode.productDetail.labelBGColor};
  padding: 5px 10px;
  border-radius: 5px;
  color: ${(props) => props.theme.mode.productDetail.textColor};
`;

export const StyledFormSelect = styled(Select)`
  width: 12vw;
  min-height: 30px !important;
  margin-top: 10px;
   .ant-select-selector {
    border-bottom: 2px solid ${(props) => props.theme.mode.productDetail.borderColor} !important;
    height: 30px !important;
    border-radius: 5px !important;
    padding: 10px !important;  // Adjust padding to align the border
  }
  .ant-select-selection-item {
    line-height: 28px;  // Adjust line-height to center text vertically
  }
`;

export const StyledFormInput = styled(Input)`
  width: 15vw;
  border-bottom: 2px solid ${(props) => props.theme.mode.productDetail.borderColor} !important;
  border-radius: 5px;
  padding: 10px;
  min-height: 30px !important;
`;



export const CardListContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;


export const StyledCard = styled(Card)<{ isHovered: boolean }>`
  margin: 10px 0px 10px 30px;
  box-shadow: ${(props) =>
    props.isHovered
      ? `${props.theme.mode.productDetail.boxShadow} !important`
      : 'none !important'};
  border-radius: 10px;
  border-bottom: 4px solid ${(props) => props.theme.mode.productDetail.borderColor} !important;
  transition: ${(props) =>
    props.isHovered
      ? 'transform 0.2s ease-in-out, box-shadow 0.3s ease, background 0.3s ease-in-out !important'
      : 'box-shadow 0.3s ease, background 1s ease-in-out !important'};
  background: ${(props) =>
    props.isHovered
      ? props.theme.mode.productDetail.hoverBackgroundGradient
      : props.theme.mode.productDetail.cardBackgroundGradient};
  color: ${(props) => props.theme.mode.productDetail.textColor};
`;

export const CardTitle = styled.div<{ isHovered: boolean }>`
  font-size: 17px;
  color: ${(props) => props.theme.mode.productDetail.textColor};
  background-color: ${(props) =>
    props.isHovered ? '#FFFFFF99' : '#FFFFFF55'};
  padding-left: 10px;
  padding-right: 10px;
  border-radius: 5px;
  border-bottom: 1px solid ${(props) => props.theme.mode.productDetail.borderColor};
`;

export const CardSubtitle = styled.div`
  margin-bottom: 5px;
  border-bottom: 1px solid ${(props) => props.theme.mode.productDetail.borderColor};
  font-size: 14px;
  font-weight: bold;
  color: ${(props) => props.theme.mode.productDetail.textColor};
`;

export const MenuContentArea = styled.div<{ isHovered: boolean }>`
  padding-top: 6px;
  border-radius: 5px;
  margin-left: 2px;
  transition: background-color 0.3s;
  background-color: ${(props) =>
    props.isHovered ? '#FFFFFF99' : '#FFFFFF55'};
`;

